import { render } from "./IconCheck.vue.js?vue&type=template&id=74046bd6!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconCheck.vue?vue&type=template&id=74046bd6"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__